import React, { useEffect, useState } from "react";
import {
  useBackProduct,
  useDeleteProduct,
  useGetLadderPorduct,
  useGetMyProductList,
  useShareProduct,
  useShareProducts,
  useShareToTelegram,
} from "../../../../hooks/useContent";
import { Container } from "../../../../theme/GlobalStyle";
import { sumPrice } from "../../../../utils/sumPrice";
import Button from "../../../Button/Button";
import { Table } from "../../../Table/Table";
import styled from "styled-components";
import { MdDeleteForever } from "react-icons/md";
import { MdSubtitles } from "react-icons/md";
import { FiEdit, FiShare } from "react-icons/fi";
import { AiOutlineRollback } from "react-icons/ai";
import { BsLadder } from "react-icons/bs";
import { useQueryClient } from "react-query";
import ConfirmDialog from "../../../Dialog/ConfirmDialog";
import ShareTelegramDialog from "../../../Dialog/ShareTelegramDialog";
import { Link } from "react-router-dom";
import Typography from "../../../Typography/Typography";
import { RenderTooltip } from "../../../Tooltip/Tooltip";
import Loading from "../../../Loadings/LoadingTable";
import EditSeo from "../../../Dialog/contentUnit/EditSeo";
import BreadCrumb from "../../../BreadCrumb/BreadCrumb";

const ActiveProduct = () => {
  const headerTitle = [
    "#",
    "عنوان محصول",
    "دسته بندی",
    "قیمت یک عدد",
    "تعداد در جین",
    "قیمت کل",
    "برند",
    "تعداد موجودی",
    "کد محصول",
    "انتشار در تلگرام",
    "عملیات",
  ];

  const queryClient = useQueryClient();
  const [search, setSearch] = useState("");
  const [PageNumber, setPageNumber] = useState(1);
  const [checked, setChecked] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogTelegram, setShowDialogTelegram] = useState(false);
  const [showSeo, setShowSeo] = useState(false);
  const [currentItem, setCurrentItem] = useState({});
  const [form, setForm] = useState("");
  const [status, setStatus] = useState({
    title: "",
    status: "",
    id: "",
  });
  const {
    data: listProduct,
    isLoading: loadingProduct,
    hasNextPage,
    fetchNextPage,
  } = useGetMyProductList(search, {
    status: "Active",
    inventoryStatus: "موجود در انبار",
  });

  const pageCount = listProduct?.pages[0]?.data?.count;

  const { mutateAsync: deleteProduct } = useDeleteProduct();

  // handle delete
  const handleDelete = async (id) => {
    await deleteProduct(id);
    setShowDialog(false);
  };

  // handle ladder
  const { mutateAsync: updateLadder } = useGetLadderPorduct();

  const handleLadder = async (productId) => {
    await updateLadder(productId);
    setShowDialog(false);
  };

  // handle share product
  const { mutateAsync: shareProduct } = useShareProduct();

  const handleShare = async (id) => {
    await shareProduct(id);
    setChecked("");
    setShowDialog(false);
  };

  // handle back product

  const { mutateAsync: goBackProduct } = useBackProduct();

  const handleBack = async (productId) => {
    const data = {
      StatusProducts: "Back",
      IdProducts: productId,
    };
    await goBackProduct(data);
    queryClient.invalidateQueries("fetch-myProduct-list", 1, "Barci");
  };

  // share product to telegram
  const { mutateAsync: shareProductToTelegram } = useShareToTelegram();

  const handleShareTelegram = async () => {
    const data = {
      product_id: status.id,
      caption: form,
    };
    await shareProductToTelegram(data);
    setShowDialogTelegram(false);
  };

  // handle share selected products
  const { mutateAsync: handleShareProduct } = useShareProducts();

  const handleShareProducts = async (checkData) => {
    await handleShareProduct(checkData);
  };
  const handleUpdateSEO = (item) => {
    setShowSeo(true);
    setCurrentItem(item);
  };
  const handleConfirmModal = (productId) => {
    switch (status.status) {
      case "delete":
        return handleDelete(productId);
      case "edit":
        return alert("Hello");
      case "share":
        return handleShare(productId);
      case "back":
        return handleBack(productId);
      case "ladder":
        return handleLadder(productId);
      default:
        return;
    }
  };

  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;
        if (hasNextPage) await fetchNextPage();
        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);

  let i = 0;

  const items = listProduct?.pages?.map((page) =>
    page?.data?.Products?.map((item, index) => {
      return (
        <tr key={item.IdProducts}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {(i += 1)}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.NameProducts}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.first_category?.NameCategories}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.PriceProducts}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.NumberInJeans}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {sumPrice(
                item?.NumberSellProducts,
                item?.NumberInJeans,
                item?.PriceProducts
              )}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.brand?.NameBrands}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.NumberInStock}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.CodeProducts}
            </span>
          </td>
          <td>
            <RenderTooltip title="انتشار محصول">
              <Button
                size="12px"
                bgColor="#17A2B8"
                small="40px"
                color="#fff"
                className="mr-2"
                onclick={() => {
                  setShowDialogTelegram(true);
                  setStatus({
                    id: item?.IdProducts,
                    status: "share-telegram",
                    title:
                      "آیا از منتشر کردن این محصصول به تلگرام مطمئن هستید ؟",
                  });
                }}
              >
                <FiShare size={20} />
              </Button>
            </RenderTooltip>
          </td>
          <td>
            <ButtonContainer>
              <RenderTooltip title="حذف محصول">
                <Button
                  size="12px"
                  bgColor="#C82333"
                  small="40px"
                  color="#fff"
                  onclick={() => {
                    setShowDialog(true);
                    setStatus({
                      title: "آیا از حذف این محصول مطمئن هستید ؟",
                      status: "delete",
                      id: item?.IdProducts,
                    });
                  }}
                >
                  <MdDeleteForever size={25} />
                </Button>
              </RenderTooltip>
              <RenderTooltip title="ویرایش محصول">
                <Button
                  size="12px"
                  bgColor="#0D6EFD"
                  small="40px"
                  color="#fff"
                  className="mr-2"
                >
                  <Link
                    to={`/dashboard/content-controller/products/editProduct?productId=${item?.IdProducts}`}
                  >
                    <Typography>
                      <FiEdit color="#fff" size={20} />
                    </Typography>
                  </Link>
                </Button>
              </RenderTooltip>
              <RenderTooltip title={"ویرایش سِو"}>
                <Button
                  size="12px"
                  bgColor="#575b92"
                  small="40px"
                  color="#fff"
                  onclick={(e) => {
                    handleUpdateSEO(item);
                  }}
                >
                  <MdSubtitles size={20} />
                </Button>
              </RenderTooltip>
              <RenderTooltip title="بازگشت محصول">
                <Button
                  size="12px"
                  bgColor="#FFC107"
                  small="40px"
                  color="#fff"
                  className="mr-2"
                  onclick={() => {
                    setShowDialog(true);
                    setStatus({
                      title: "آیا از بازگشت این محصول مطمئن هستید ؟",
                      status: "back",
                      id: item?.IdProducts,
                    });
                  }}
                >
                  <AiOutlineRollback size={20} />
                </Button>
              </RenderTooltip>
              <RenderTooltip title="نردبان کردن">
                <Button
                  size="12px"
                  bgColor="#868E96"
                  small="40px"
                  color="#fff"
                  className="mr-2"
                  onclick={() => {
                    setShowDialog(true);
                    setStatus({
                      id: item?.IdProducts,
                      status: "ladder",
                      title:
                        "آیا از نردبان کردن این محصصول به تلگرام مطمئن هستید ؟",
                    });
                  }}
                >
                  <BsLadder size={20} />
                </Button>
              </RenderTooltip>
            </ButtonContainer>
          </td>
        </tr>
      );
    })
  );

  return (
    <>
      <BreadCrumb
        margin="mt-3"
        num1="واحد محتوا"
        num2="محصولات"
        num3="محصولات فعال"
        href1="/dashboard/content-controller"
        href2="/dashboard/content-controller/products"
      />
      <Container>
        <Table
          title={`محصولات فعال (${pageCount || "-"})`}
          headerTitle={headerTitle}
          items={items}
          setSearch={setSearch}
        />
        <ConfirmDialog
          show={showDialog}
          title={status.title}
          handleClose={() => setShowDialog(false)}
          onSuccess={() => handleConfirmModal(status.id)}
          successTitle="تایید"
          feildTitle="منصرف شدم"
        />
        <ShareTelegramDialog
          title={status.title}
          setForm={setForm}
          form={form}
          show={showDialogTelegram}
          handleClose={() => setShowDialogTelegram(false)}
          successHandler={handleShareTelegram}
        />
        <EditSeo
          show={showSeo}
          IdRefrenceSeo={currentItem?.IdProducts}
          handleClose={() => {
            setShowSeo(false);
          }}
          locationSeo="Product"
          item={currentItem}
        />
      </Container>
    </>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
  gap: 1rem;
`;

export default ActiveProduct;
